import { render, staticRenderFns } from "./my-ads.vue?vue&type=template&id=d346631e&"
import script from "./my-ads.vue?vue&type=script&lang=js&"
export * from "./my-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports